import { render } from "./AdminParentTemp.vue?vue&type=template&id=37f61815&scoped=true"
import script from "./AdminParentTemp.vue?vue&type=script&lang=js"
export * from "./AdminParentTemp.vue?vue&type=script&lang=js"

import "./AdminParentTemp.vue?vue&type=style&index=0&id=37f61815&lang=stylus&scoped=true"

import exportComponent from "D:\\01.WorkData\\05.WebProjects\\04.SourceCode\\02.Vue\\project_110_008\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f61815"]])

export default __exports__